import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { getTETable } from "src/Requests/deltaHedgeBackTest";
import {
  IBackTestSearchParams,
  IDecileTE,
} from "src/Interfaces/deltaHedgeBackTest";

interface IProps {
  searchParams: IBackTestSearchParams;
  onRowClick: (row: IDecileTE) => void;
  activeRowId?: number;
}

const TETable = ({ searchParams, onRowClick, activeRowId }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          onTableRowClick={onRowClick}
          activeRowId={activeRowId}
        />
      )}
      getDataTable={getTETable}
      searchParameters={searchParams}
    />
  );
};

export default TETable;
